<div class="c-stop-header__nav c-stop-nav">

    <button type="button" class="c-stop-nav__btn c-icon-btn"
        [disabled]="activePortCall()?.id == null || activePortCall()?.id == firstPortCall()?.id"
        [attr.aria-label]="'voyage.portCallPrevious' | translate" (click)="onPreviousPortCall()">
        <span class="fa fa-angle-left"></span>
    </button>

    <select class="c-stop-nav__locations c-icon-btn" (change)="onChangePortCallSelected($event)">
        <option value="" disabled>{{ 'voyage.portCallPlaceholder' | translate}}</option>
        @for (portCall of activeVoyage()?.portCalls; track $index) {
        <option [value]="portCall.id" [selected]="portCall.id === activePortCall()?.id">
            {{ $index + 1 }}. {{ portCall.portDetails?.fullName }}{{ portCall.portDetails?.terminal ? ' - ' +
            portCall.portDetails?.terminal : '' }}, {{ portCall.portDetails?.country }}{{ portCall.isTransshipmentHub ?
            ' · ' + ('voyage.transshipmentHub' | translate) : '' }}
        </option>
        }
    </select>

    <button type="button" class="c-stop-nav__btn c-icon-btn"
        [disabled]="activePortCall()?.id == null || activePortCall()?.id == lastPortCall()?.id"
        (click)="onNextPortCall()">
        <span class="fa fa-angle-right"></span>
    </button>

</div> <!-- .c-stop-nav -->
